import { DocUploadField } from "./DocUploadField";
import { fieldCls, labelCls } from "./ui";

export const BookSaleSection = ({ form, setForm, onBusy }) => {
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));
  const setEpub = (_url, size, res) => setForm((f) => ({
    ...f, epub_venta_uid: res?.upload_id || "", epub_venta_nombre: res?.filename || "", epub_venta_size: size || 0,
  }));

  return (
    <div className="border-t border-[#0f2544]/8 pt-4" data-testid="book-sale-section">
      <p className={labelCls}>Ebook EPUB · venta directa</p>
      <label className="flex items-center gap-2 text-sm font-medium text-[#0f2544] rounded-lg bg-[#eef1ff] border border-[#1f44e0]/20 px-3 py-2.5 cursor-pointer">
        <input type="checkbox" checked={form.venta_directa} onChange={set("venta_directa")} className="accent-[#1f44e0]" data-testid="book-venta-directa" />
        Vender el EPUB en la web: marca aquí para poner el precio y subir el archivo EPUB
      </label>
      {form.venta_directa && (
        <div className="mt-4 rounded-xl border border-[#0f2544]/10 p-4 space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className={labelCls}>Precio en euros (€)</label><input type="number" min="0" step="0.01" value={form.precio_eur} onChange={set("precio_eur")} className={fieldCls} placeholder="Ej: 9.99" data-testid="book-precio-eur" /></div>
          </div>
          <p className="text-xs text-[#8a8a83]">En Europa se cobra en euros. Fuera de Europa se cobra en dólares (USD), convertidos automáticamente con el cambio oficial del Banco Central Europeo. Las ofertas se programan en Admin › Ventas.</p>
          <DocUploadField kind="EPUB" privado url={form.epub_venta_uid} size={form.epub_venta_size} label={form.epub_venta_nombre} onChange={setEpub} onBusy={onBusy} />
          <p className="text-xs text-[#8a8a83]">Este archivo es privado: solo lo reciben los clientes que han pagado.</p>
        </div>
      )}
    </div>
  );
};
